import { render, staticRenderFns } from "./OdontogramaAtendimentoTabela.vue?vue&type=template&id=b005d144&scoped=true"
import script from "./OdontogramaAtendimentoTabela.vue?vue&type=script&lang=js"
export * from "./OdontogramaAtendimentoTabela.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaAtendimentoTabela.vue?vue&type=style&index=0&id=b005d144&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b005d144",
  null
  
)

export default component.exports